/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const PersonAbsentIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <circle cx="18.5" cy="18.5" r="5" />
      <path d="M16.25,16.25 L20.75,20.75" />
      <path d="M20.75,16.25 L16.25,20.75" />
      <path d="M12.5,14.5 L12.5,11.696" />
      <path d="M7.5,11.696 L7.5,14.5 L2.491,16.289 C1.297,16.716 0.5,17.847 0.5,19.114 L0.5,21.5 L11.5,21.5" />
      <ellipse cx="10" cy="6.5" rx="5" ry="6" />
      <path d="M14.953,5.953 C14.785,5.974 14.669,5.967 14.5,6 C12.797,6.328 11.703,5.711 10.766,4.07 C10.203,5.148 8.444,6 7,6 C6.289,6 5.677,5.854 5.064,5.534" />
    </g>
  </svg>
);

export default PersonAbsentIcon;
